import React from "react";
import ErrorMessage from "../interfaces/ErrorMessage";
import loading from "../../public/images/svg/loading.svg";

const LoadingPage: React.FC<ErrorMessage> = ({ title }) => (
  <div>
    <div className="z-10 h-full w-full place-content-center">
      <div className="mx-auto mt-80 object-center w-16 h-16">
        <img src={loading} alt="loading..." />
      </div>
      <div className="pt-4 text-lg text-center">{title}</div>
    </div>
  </div>
);

export default LoadingPage;
